import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import { Box, Grid, Button, tooltipClasses, TooltipProps, styled, Tooltip } from '@mui/material';
import { useState } from 'react';
import {
  WsButton,
  WsColors,
  WsDialog,
  WsDialogSize,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import { AppLayoutTheme } from '../../../candidates/utils/CandidateHelper';
import { Credits } from '../../utils/vendorsHelper';
import SharedCredits from '../shareCredits';

const CreditsButton = styled(Button)(() => ({
  color: WsColors.TertiaryShades500,
  '&:hover': {
    backgroundColor: WsColors.TheBlues900,
  },
}));

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: WsColors.TertiaryShades800,
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.4)',
    borderRadius: '4px',
  },
});
interface VendorTopBannerProps {
  credits: Credits;
  allotedCredits: number;
  pageRefresh: () => void;
}
const VendorTopBanner = ({ credits, allotedCredits, pageRefresh }: VendorTopBannerProps) => {
  const [open, setOpen] = useState(false);

  const toolTipText = (
    <Box p={1}>
      <Grid container spacing={1}>
        <Grid item display={'flex'} justifyContent="space-between" xs={12}>
          <Box>
            <WsTypography color={WsTypoColors.WHITE} variant={WsTypoVariants.BODY1}>
              Used Credits
            </WsTypography>
            <WsTypography color={WsTypoColors.WHITE} variant={WsTypoVariants.SUB_TITLE} bold>
              {`${credits?.used + allotedCredits}`}
            </WsTypography>
          </Box>
          <Box>
            <WsTypography color={WsTypoColors.WHITE} variant={WsTypoVariants.BODY1}>
              Total Credits
            </WsTypography>
            <WsTypography color={WsTypoColors.WHITE} variant={WsTypoVariants.SUB_TITLE} bold>
              {credits.balance + credits.used}
            </WsTypography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <WsTypography color={WsTypoColors.WHITE} variant={WsTypoVariants.BODY1}>
            It costs 1 Credit per email you sent. The total credit resets daily
          </WsTypography>
        </Grid>
      </Grid>
    </Box>
  );

  return (
    <AppLayoutTheme>
      <Grid container item xs={12} alignItems="center" p={2} justifyContent="space-between">
        <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.WHITE}>
          Vendor List
        </WsTypography>
        <Box>
          <CustomWidthTooltip title={toolTipText} placement="left-start">
            <CreditsButton variant="text" startIcon={<InfoOutlinedIcon />} size="small">
              Remaining Credits
            </CreditsButton>
          </CustomWidthTooltip>
          <Grid xs={12} item container justifyContent="flex-end" pr={1}>
            <WsTypography color={WsTypoColors.WHITE} variant={WsTypoVariants.SUB_TITLE}>
              {`${credits?.balance - allotedCredits}`}
            </WsTypography>
          </Grid>
          <WsButton
            variant="text"
            onClick={() => setOpen(true)}
            startIcon={<ShareOutlinedIcon />}
            size="small"
          >
            Share Credits
          </WsButton>
        </Box>
        <WsDialog openDialog={open} size={WsDialogSize.MEDIUM}>
          <SharedCredits
            closeDilog={() => {
              setOpen(false);
              pageRefresh();
            }}
          />
        </WsDialog>
      </Grid>
    </AppLayoutTheme>
  );
};
export default VendorTopBanner;
